export default {
  title: 'Términos y condiciones',
  description: {
    part1: 'Para el procesamiento, tratamiento y transferencia de ',
    part2: 'nuevo contenido',
    part3: ' es necesario que aceptes los términos y condiciones.'
  },
  accept: 'Acepto los ',
  terms: 'Términos y condiciones',
  laterButton: 'Ahora no',
  saveButton: 'Guardar'
}

export const en = {
  title: 'Terms and conditions',
  description: {
    part1: 'For processing, treatment and transfer of ',
    part2: 'new content ',
    part3: 'you need to accept the terms and conditions.'
  },
  accept: 'I accept the ',
  terms: 'Terms and conditions',
  laterButton: 'Not now',
  saveButton: 'Save'
}

export const ca = {
  title: 'Termes i condicions',
  description: {
    part1: 'Per al processament, tractament i transferència de ',
    part2: 'nou contingut ',
    part3: 'és necessari que acceptis els termes i condicions.'
  },
  accept: 'Accepto els ',
  terms: 'Termes i condicions',
  laterButton: 'Ara no',
  saveButton: 'Desar'
}
